<template>
  <v-container
    :pa-6="$vuetify.breakpoint.xsOnly"
  >

    <v-layout>
      <v-form>
        <v-alert type="info" dismissible v-model="alert">
          Your account has been updated.
        </v-alert>
        <v-text-field
          prepend-icon="person"
          name="login"
          label="New email"
          type="text"
          v-model="email"
          :error-messages="errors.email"
        ></v-text-field>

        <v-text-field
          prepend-icon="lock"
          name="password1"
          label="New password"
          type="password"
          v-model="password1"
          :error-messages="errors.password1"
        ></v-text-field>

        <v-text-field
          prepend-icon="lock"
          name="password2"
          label="Repeat new password"
          type="password"
          v-model="password2"
          :error-messages="errors.password2"
        ></v-text-field>

        <v-btn
          color="primary"
          @click="save()"
          :loading="loading"
        >
          Save
        </v-btn>
      </v-form>
    </v-layout>
  </v-container>
</template>

<script>
  import mixinsPages from '@/mixins/pages'
  import * as auth from '@/services/auth'

  export default {
    title: 'User profile',
    mixins: [mixinsPages],
    data () {
      return {
        email: auth.getUser().user.email,
        password1: '',
        password2: '',
        message: null,
        loading: false,
        alert: false,
        errors: {
          email: [],
          password1: [],
          password2: []
        }
      }
    },
    methods: {
      async save () {
        try {
          this.loading = true
          const data = await this.$axios.post('profile', {
            email: this.email,
            password1: this.password1,
            password2: this.password2
          })
          this.alert = true
          this.loading = false
          this.errors = {}
        } catch (error) {
          this.loading = false
          this.alert = false
          this.errors = error.response.data
        }
      },
      dashboard () {
        this.$router.push({name: 'dashboard'})
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/profile.vue